<div class="editor-root">
  <div class="ms-ev-picker-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Master Suite</mat-label>
      <mat-select [formControl]="masterSuiteControl">
        @for (ms of masterSuites; track ms.id) {
          <mat-option [value]="ms.id">{{ ms.name }}</mat-option>
        }
      </mat-select>
      @if (msLocked) {
        <mat-icon matSuffix class="lock-icon" aria-label="Master suite locked">lock</mat-icon>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Enhancement Variant</mat-label>
      <mat-select [formControl]="evControl" placeholder="Pick an EV…">
        @for (ev of availableEvs; track ev.id) {
          <mat-option [value]="ev.id" [disabled]="isEvDisabled(ev.id)">
            {{ ev.name }}
            @if (isEvDisabled(ev.id)) {
              <span class="option-badge">configured</span>
            }
          </mat-option>
        }
      </mat-select>
      @if (evLocked) {
        <mat-icon matSuffix class="lock-icon" aria-label="Enhancement variant locked">lock</mat-icon>
      }
    </mat-form-field>
  </div>

  @if (msLocked) {
    <div class="picker-hint">
      Both locked — MS and EV a convention targets can't change after creation. Delete + create a new entry to retarget.
    </div>
  }

  @if (!showPlaceholder) {
    <div class="template-block">
      <label class="template-label">Template</label>
      <app-token-chip-picker
        [value]="templateControl.value"
        [vocabulary]="templateVocabulary"
        [showReset]="true"
        hint="Per-select rows below seed from this template; each row's chips are independent after seeding."
        (valueChange)="onTemplateChange($event)"
      ></app-token-chip-picker>
    </div>

    <div class="section-header">
      <h3 class="section-title">Per-select patterns ({{ perSelectRows.length }})</h3>
    </div>

    @if (perSelectRows.length === 0) {
      <div class="per-select-empty">No per-select rows to configure for the picked EV.</div>
    } @else {
      <div class="select-rows">
        @for (row of perSelectRows; track row.asset.id; let rowIndex = $index) {
          <div class="select-row">
            <div class="select-row-top">
              <div class="select-index">
                {{ rowIndex + 1 }}
                <mat-icon class="media-icon">{{ row.asset.masterSuiteTouchAsset.type === 'Video' ? 'movie' : 'image' }}</mat-icon>
              </div>
              <div
                class="row-chip-slot"
                data-cy="per-select-token-chip-droplist"
                cdkDropList
                cdkDropListOrientation="horizontal"
                (cdkDropListDropped)="dropPerSelectChip(rowIndex, $event)"
              >
                @for (chip of row.tokenFormats; track $index; let chipIndex = $index) {
                  @if (isChipLocked(chip)) {
                    @if (isTokenChip(chip)) {
                      <span class="chip locked" title="Token">
                        {{ slotTokenLabel(chipTokenSlug(chip)) }}
                      </span>
                    } @else if (isSeparatorChip(chip)) {
                      <span class="per-select-locked-sep">
                        <span class="sep-glyph">{{ chip.value }}</span>
                      </span>
                    } @else {
                      <span class="chip locked" title="Template chip">
                        @if (chip.value.length > 0) {
                          {{ chip.value }}
                        } @else {
                          <span class="chip-empty-placeholder">custom</span>
                        }
                      </span>
                    }
                  } @else {
                    <span class="per-select-custom-chip" cdkDrag>
                      <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
                      <input
                        class="per-select-custom-input"
                        type="text"
                        [value]="chip.value"
                        placeholder="a-z A-Z 0-9 _-."
                        (keydown)="onCustomKeyDown($event)"
                        (input)="onPerSelectChipInput(rowIndex, chipIndex, $event)"
                      />
                      <span
                        class="rm"
                        role="button"
                        tabindex="0"
                        (click)="removePerSelectChip(rowIndex, chipIndex)"
                        (keydown.enter)="removePerSelectChip(rowIndex, chipIndex); $event.preventDefault()"
                        aria-label="Remove custom value"
                      >✕</span>
                    </span>
                  }
                }
              </div>
              <div class="per-select-outside-actions">
                <button
                  type="button"
                  class="chip-add-per-select-custom"
                  (click)="addPerSelectCustomChip(rowIndex)"
                  aria-label="Add per-select custom value"
                >
                  + custom
                </button>
                <button
                  mat-icon-button
                  type="button"
                  class="reset-btn"
                  (click)="resetRow(rowIndex)"
                  aria-label="Clear per-select values"
                  matTooltip="Clear per-select values"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </div>
            </div>
            <div class="select-preview">
              @if (row.preview.error) {
                <span class="preview-error">{{ row.preview.error.description }}</span>
              } @else {
                <span class="preview-filename">{{ row.preview.value }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  }

  @if (showReasonPicker) {
    <mat-form-field appearance="outline" class="form-field reason-field">
      <mat-label>Reason</mat-label>
      <mat-select [formControl]="reasonControl">
        @for (r of selectableReasons; track r) {
          <mat-option [value]="r">{{ reasonLabel(r) }}</mat-option>
        }
      </mat-select>
      <mat-hint>
        Required. Each save creates a new revision; the reason is stored in the audit log.
      </mat-hint>
    </mat-form-field>

    @if (isOtherReason) {
      <mat-form-field appearance="outline" class="form-field reason-detail-field">
        <mat-label>Explain</mat-label>
        <input matInput type="text" [formControl]="detailControl" />
      </mat-form-field>
    }
  }
</div>
